import Swal from "sweetalert2";
import { getActivationURLApi, signInApi, verifyOTPApi } from "../apis/authService"
import { empty, extractDataFromArray, signInCallback } from "./utils&validatation";

const MFA = {
    enabled: false,
    ssoType: "",
    token: "",
    getActivationLink: async (email, passwd, token) => {
        try {
            const response = await getActivationURLApi({ cmd: "getActivationURL", auth_token_str: token, qr_img_required: true });  

            if (extractDataFromArray(response, ["data"], "") !== "") {
                MFA.showConfirm2FAPopup(extractDataFromArray(response, ["data", "url"], ""), email, passwd, token, extractDataFromArray(response, ["data", "qr_img"], ""));
            }
        } catch (err) {
            console.error("Error in getActivationLinkApi: ", err);
            // showAlertMessage("E", extractDataFromArray(response, ["errorMsg"], "Error Occured"));
        }
    },

    showConfirm2FAPopup: (link, email, passwd, token, qrImg = "") => {
        Swal.fire({
            html: `
            <div class="modal-header text-center">
                <h5 class="modal-title">Two-factor Authentication</h5>
                
            </div>
            <div class="p-4">
                🔐🔢
                <h6>Set up two-factor authentication</h6>
                <p>
                    To be able to login you need to scan this QR code with any Authentication app
                    and enter verification code below
                </p>
                <div class="mb-4"
                    style="border: solid 1px var(--light-color); max-width: 200px; padding: 20px; border-radius: 8px;     margin: auto;">
                    <img src="${qrImg}"
                        class="img-fluid" id="mfa_qr"/>
                </div>
                <form>
                    <div class="form-group">
                        <label class="mb-2">Enter the 6-digit authentication code
                            generated by your app:</label>
                        <input type="text" pattern="\d*" class="form-control m-auto" id="mfa_otp"
                            placeholder="- - - - - -"
                            maxlength="6"
                            style="max-width: 160px; letter-spacing: 10px; text-align: left;">
                            <div class="m-auto text-danger font-12 pt-1 d-none" id="invalid-otp-msg">Invalid OTP</div>
                    </div>
                </form>
            </div>`,
            showConfirmButton: false,
            allowOutsideClick: false,
            showCloseButton: true,
            allowEnterKey: true,
            customClass: {
                popup: 'swal_popup_with_no_padding',
                content: 'swal_popup_with_no_padding',
                close: 'swal_popup_close',
            },
            willOpen: () => {
                // Use Swal.getPopup() to access elements inside the popup safely
                const popup = Swal.getPopup();
                if (!popup) return;

                const otpEl = popup.querySelector("#mfa_otp");
                const invalidMsg = popup.querySelector("#invalid-otp-msg");

                // Ensure it's hidden on open (both class + inline style)
                if (invalidMsg) {
                    invalidMsg.classList.add("d-none");
                    invalidMsg.style.display = "none";
                }

                // focus after slight delay (Swal animation)
                setTimeout(() => {
                    if (otpEl) otpEl.focus();
                }, 500);

                if (otpEl) {
                    otpEl.addEventListener("input", (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const mfaOtpInput = e.target;

                        // Clean state before user retypes (both class and inline)
                        mfaOtpInput.classList.remove("invalid-otp");
                        if (invalidMsg) {
                            invalidMsg.classList.add("d-none");
                            invalidMsg.style.display = "none";
                        }

                        // Strip non-numeric chars
                        let otp = mfaOtpInput.value.replace(/[^0-9]/g, '');
                        mfaOtpInput.value = otp;
                        if (otp.length === 6) {
                            MFA.verifyOTP(otp, token)
                        }
                    })
                }
            },
        })
    },

    verifyOTP: async (totp, token) => {
        try {
            const popup = Swal.getPopup();
            const otpInput = (popup && popup.querySelector("#mfa_otp")) || document.getElementById("mfa_otp");
            const invalidMsg = (popup && popup.querySelector("#invalid-otp-msg")) || document.getElementById("invalid-otp-msg");

            const response = await verifyOTPApi({ cmd: "verifyTOTP", totp: totp, auth_token_str: token });

            if (!empty(extractDataFromArray(response, ["data"], ""))) {
                if (!empty(token)) {
                    signInCallback({ cmd: 'signIn' }, response)
                }
                MFA.enabled = true
                Swal.close();
                // MFA.showActivated2FAPopup()
            } else {
                invalidMsg.classList.add("d-none");
                invalidMsg.style.display = "block";
                otpInput && otpInput.focus();
            }
        } catch (err) {
            console.error("Error in verifyOtpApi: ", err)
        }
    },

    showVerify2FAPopup: (email = '', passwd = '') => {
        Swal.fire({
            html: `<div class="swal2-content swal_popup_with_no_padding">
                <div class="modal-header text-center">
                    <h5 class="modal-title">Two-factor Authentication</h5>
                </div>
                <div class="p-12">
                    <form>
                        <input type="hidden" name="email" value="${email}">
                        <input type="hidden" name="passwd" value="${passwd}">
                        <div class="form-group">
                            <label class="mb-4">Open the two-factor authentication app on your device and enter the 6 digit code below to verify</label>
                            <input type="text" pattern="\\d*" class="form-control m-auto" id="mfa_otp" placeholder="- - - - - -" maxlength="6" style="max-width: 160px;letter-spacing: 10px; text-align: left;">
                            <!-- inline style ensures it's hidden even if d-none is missing -->
                            <div id="invalid-otp-msg" class="m-auto text-danger font-12 pt-1 d-none" style="display:none">Invalid OTP</div>
                        </div>
                    </form>
                    <div class="flex justify-between">
                        <button class="btn btn-secondary" type="button" id="btn_verify_close">Cancel</button>
                        <button class="btn btn-primary" type="button" id="btn_verify">Verify</button>
                    </div>
                </div>
            </div>`,
            showConfirmButton: false,
            allowEnterKey: true,
            allowOutsideClick: false,
            showCloseButton: true,
            customClass: {
                popup: 'swal_popup_with_no_padding',
                content: 'swal_popup_with_no_padding',
                close: 'swal_popup_close',
            },
            willOpen: () => {
                // Use Swal.getPopup() to access elements inside the popup safely
                const popup = Swal.getPopup();
                if (!popup) return;

                const otpEl = popup.querySelector("#mfa_otp");
                const invalidMsg = popup.querySelector("#invalid-otp-msg");
                const btnClose = popup.querySelector("#btn_verify_close");
                const btnVerify = popup.querySelector("#btn_verify");

                // Ensure it's hidden on open (both class + inline style)
                if (invalidMsg) {
                    invalidMsg.classList.add("d-none");
                    invalidMsg.style.display = "none";
                }

                // focus after slight delay (Swal animation)
                setTimeout(() => {
                    if (otpEl) otpEl.focus();
                }, 500);

                if (btnClose) {
                    btnClose.addEventListener("click", () => {
                        Swal.close();
                    });
                }

                if (btnVerify) {
                    btnVerify.addEventListener("click", () => {
                        if (!otpEl) return;

                        const otp = otpEl.value || "";

                        // hide error before attempt
                        otpEl.classList.remove("invalid-otp");
                        if (invalidMsg) {
                            invalidMsg.classList.add("d-none");
                            invalidMsg.style.display = "none";
                        }

                        if (otp.length === 6) {
                            if (MFA.ssoType) {
                                MFA.signInSSOWithOTP(otp);
                            } else {
                                const emailInput = popup.querySelector("input[name=email]");
                                const passwdInput = popup.querySelector("input[name=passwd]");
                                const emailVal = emailInput ? emailInput.value : "";
                                const passwdVal = passwdInput ? passwdInput.value : "";
                                MFA.signInWithOTP(emailVal, passwdVal, otp);
                            }
                        }
                    });
                }

                if (otpEl) {
                    otpEl.addEventListener("input", (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const mfaOtpInput = e.target;

                        // Clean state before user retypes (both class and inline)
                        mfaOtpInput.classList.remove("invalid-otp");
                        if (invalidMsg) {
                            invalidMsg.classList.add("d-none");
                            invalidMsg.style.display = "none";
                        }

                        // Strip non-numeric chars
                        let otp = mfaOtpInput.value.replace(/[^0-9]/g, '');
                        mfaOtpInput.value = otp;

                        if (otp.length === 6) {
                            if (MFA.ssoType) {
                                MFA.signInSSOWithOTP(otp);
                            } else {
                                const emailInput = popup.querySelector("input[name=email]");
                                const passwdInput = popup.querySelector("input[name=passwd]");
                                const emailVal = emailInput ? emailInput.value : "";
                                const passwdVal = passwdInput ? passwdInput.value : "";
                                MFA.signInWithOTP(emailVal, passwdVal, otp);
                            }
                        }
                    });
                }
            },
        })
    },

    signInWithOTP: async (email, passwd, totp) => {
        let data = {
            cmd: 'signIn',
            email,
            pass: passwd,
            totp
        }

        try {
            const response = await signInApi(data);

            // Prefer elements inside the current Swal popup, but fallback to document.getElementById
            const popup = Swal.getPopup();
            const otpInput = (popup && popup.querySelector("#mfa_otp")) || document.getElementById("mfa_otp");
            const invalidMsg = (popup && popup.querySelector("#invalid-otp-msg")) || document.getElementById("invalid-otp-msg");

            // hide before checking (both class + inline)
            if (otpInput) otpInput.classList.remove("invalid-otp");
            if (invalidMsg) {
                invalidMsg.classList.add("d-none");
                invalidMsg.style.display = "none";
            }

            if (extractDataFromArray(response, ['data', 'login_error_code'], '') !== "TOTP_INVALID") {
                signInCallback(data, response);
                Swal.close();
            } else {
                if (otpInput) otpInput.classList.add("invalid-otp");
                if (invalidMsg) {
                    invalidMsg.classList.remove("d-none");
                    // use block to make it visible (or '' to let CSS decide)
                    invalidMsg.style.display = "block";
                    // ensure focus for quick retry
                    otpInput && otpInput.focus();
                }
            }
        } catch (err) {
            console.error("SignInWithOTP error =>", err);
        }
    },

    signInSSOWithOTP: async (totp) => {
        let data = {
            cmd: MFA.ssoType === "google" ? "verifyGoogleToken" : 'verifyMSToken',
            token: MFA.token,
            account_id: extractDataFromArray(window.location.pathname.split("/"), [1], ''),
            totp,
        }

        try {
            const response = await signInApi(data);

            const popup = Swal.getPopup();
            const otpInput = (popup && popup.querySelector("#mfa_otp")) || document.getElementById("mfa_otp");
            const invalidMsg = (popup && popup.querySelector("#invalid-otp-msg")) || document.getElementById("invalid-otp-msg");

            // hide before checking (both class + inline)
            if (otpInput) otpInput.classList.remove("invalid-otp");
            if (invalidMsg) {
                invalidMsg.classList.add("d-none");
                invalidMsg.classList.add("invalid-otp")
                invalidMsg.style.display = "none";
            }

            if (extractDataFromArray(response, ['data', 'login_error_code'], '') !== "TOTP_INVALID") {
                signInCallback(data, response);
                Swal.close();
            } else {
                if (otpInput) otpInput.classList.add("invalid-otp");
                if (invalidMsg) {
                    invalidMsg.classList.remove("d-none");
                    invalidMsg.style.display = "block";
                    otpInput && otpInput.focus();
                }
            }
        } catch (err) {
            console.errror("SignInSSOWithOTP err", err);
        }
    },
}

export default MFA;